<template>
    <div :class="phoneClass || 'device-table'">
        <!-- 移动端-搜索栏 -->
        <div class="search-container" v-if="phoneClass">
            <div class='left'>
                <el-input
                    :placeholder="$t('devicePage.imei')"
                    prefix-icon="el-icon-search"
                    v-model="searchForm.key"
                    @change="initPage(),getDeviceList()"
                >
                </el-input>
            </div>
            <div class="right">
                <div class="screen" @click="screen">
                    <span :class="{handleScreen: mobileSearch.handleScreen}">{{$t("devicePage.screen")}}</span>
                    <img src="../assets/img/icon/home-shaixuan-active.png" alt="" v-if="mobileSearch.handleScreen">
                    <img src="../assets/img/icon/home-shaixuan.png" alt="" v-else>
                </div>
            </div>
        </div>
        <!-- 移动端--搜索内容 -->
        <div class="search-bar" v-if="mobileSearch.handleScreen">
            <div class="status-index">
                <span>{{$t("devicePage.status")}}</span>
                <el-select v-model="searchForm.status" clearable style="width:130px;" :placeholder="$t('message.select')" @change="initPage(), getDeviceList()">
                    <el-option
                            v-for="item in deviceStatusList"
                            :key="item.index"
                            :label="$t('selectData.device.status.status'+item.value)"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="status-index">
                <span>{{$t("devicePage.type")}}</span>
                <el-select v-model="searchForm.type" clearable style="width:130px;" :placeholder="$t('message.select')" @change="initPage(), getDeviceList()">
                    <el-option
                        v-for="item in typeList"
                        :key="item.index"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="status-index">
                <span>{{$t("setting.province")}}</span>
                <el-input
                    v-model="searchForm.province"
                    clearable
                    :placeholder="$t('message.select')"
                    @change="initPage(),getDeviceList()">
                </el-input>
            </div>
            <div class="status-index">
                <span>{{$t("setting.city")}}</span>
                <el-input
                    v-model="searchForm.city"
                    clearable
                    :placeholder="$t('message.select')"
                    @change="initPage(),getDeviceList()">
                </el-input>
            </div>
            <!--设备应用-->
            <div class="status-index" >
                <span style="width: 80px">{{$t("devicePage.application")}}</span>
                <el-input
                    v-model="searchForm.application"
                    clearable
                    :placeholder="$t('message.select')"
                    @change="initPage(),getDeviceList()">
                </el-input>
            </div>
            <div class="status-index">
                <span>{{$t("devicePage.lora_band")}}</span>
                <el-select v-model="searchForm.lora_band"
                           clearable
                           :placeholder="$t('message.select')"
                           @change="initPage(),getDeviceList()">
                    <el-option
                            v-for="item in loraBandList"
                            :key="item"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="status-index">
                <span>{{$t("devicePage.email")}}</span>
                <el-input
                    v-model="searchForm.email"
                    clearable
                    :placeholder="$t('message.enter')"
                    @change="initPage(),getDeviceList()">
                </el-input>
            </div>
            <div class="btns">
                <el-button @click="initPage(),create()">{{$t("devicePage.reset")}}</el-button>
                <el-button type="primary" @click="initPage(),getDeviceList()">{{$t("devicePage.search")}}</el-button>
            </div>

        </div>
        <!-- web-搜索栏 -->
        <div class="search-container" v-if="!phoneClass">
            <div class="search-bar">
                <div class="search-left">
                    <div class="status-index">
                        <span class="top-title">{{$t("devicePage.status")}}</span>
                        <el-select v-model="searchForm.status" clearable style="width:130px;" :placeholder="$t('message.select')" @change="initPage(), getDeviceList()">
                            <el-option
                                    v-for="item in deviceStatusList"
                                    :key="item.index"
                                    :label="$t('selectData.device.status.status'+item.value)"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="status-index">
                        <span class="top-title">{{$t("devicePage.type")}}</span>
                        <el-select v-model="searchForm.type" clearable style="width:130px;" :placeholder="$t('message.select')" @change="initPage(), getDeviceList()">
                            <el-option
                                v-for="item in typeList"
                                :key="item.index"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="status-index">
                        <span class="top-title" v-if="phoneClass">{{$t('devicePage.imei')}}</span>
                        <el-input
                            :placeholder="$t('devicePage.search_placeholder')"
                            style="width:330px"
                            v-model="searchForm.key"
                            @change="initPage(),getDeviceList()">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                    <div class="status-index">
                        <el-button type="primary" @click="initPage(),getDeviceList()">{{$t("devicePage.search")}}</el-button>
                        <el-button @click="initPage(),create()">{{$t("devicePage.reset")}}</el-button>
                    </div>
                     <div class="batch-delete-btn" style="margin-left: 10px;" v-if="pageType === 'device' && (user.role === 1 || user.role === 100)">
                        <el-button type="danger" size="small" @click="handleBatchDelete" :disabled="selectedDevices.length === 0">
                            {{$t('devicePage.batchDelete')}}
                        </el-button>
                    </div>
                </div>

                <div class="search-right" v-if="!phoneClass">
                    <div class="deviceSuperBtn">
                        <button @click="deviceSuperBtn" :style="{cursor:'pointer',background:style.background,border:style.border,color:style.color}">
                            <span>{{$t('devicePage.screen')}}</span>
                            <img src="../assets/img/btn/arrow.png" :style="{transition: '500ms',width: '12px', transform:style.rotate}"  alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="search-bar superBtn" :style="{opacity:style.opacity,zIndex:style.zIndex,top:style.top,height:style.height}">
                <div class="search-left" >
                    <!--地区-->
                    <div class="status-index">
                        <span class="top-title">{{$t("setting.province")}}</span>
                        <el-input
                            v-model="searchForm.province"
                            clearable
                            :placeholder="$t('message.select')"
                            @change="initPage(),getDeviceList()">
                        </el-input>
                    </div>
                    <div class="status-index">
                        <span class="top-title">{{$t("setting.city")}}</span>
                        <el-input
                            v-model="searchForm.city"
                            clearable
                            :placeholder="$t('message.select')"
                            @change="initPage(),getDeviceList()">
                        </el-input>
                    </div>
                    <!--设备应用-->
                    <div class="status-index" >
                        <span class="top-title" style="width: 80px">{{$t("devicePage.application")}}</span>
                        <el-input
                            v-model="searchForm.application"
                            clearable
                            :placeholder="$t('message.select')"
                            @change="initPage(),getDeviceList()">
                        </el-input>
                    </div>
                    <div class="status-index">
                        <span class="top-title">{{$t("devicePage.lora_band")}}</span>
                        <el-select v-model="searchForm.lora_band"
                                   clearable
                                   :placeholder="$t('message.select')"
                                   @change="initPage(),getDeviceList()">
                            <el-option
                                    v-for="item in loraBandList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="status-index">
                        <span class="top-title">{{$t("devicePage.email")}}</span>
                        <el-input
                            v-model="searchForm.email"
                            clearable
                            :placeholder="$t('message.enter')"
                            @change="initPage(),getDeviceList()">
                        </el-input>
                    </div>
                </div>
            </div>
        </div>

        <!-- web端 -->
        <div class="table-outer" :style="{position:'relative',top:style.top,transition: '500ms'}" style="margin-bottom: 10px;" v-if="!phoneClass">
            <!--outer_device_id-->
            <el-table ref="deviceTable" size="small" :data="deviceList" row-key="id" :row-class-name="getDeviceRowClassName" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%;" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" v-if="pageType === 'device' && (user.role === 1 || user.role === 100)"></el-table-column>
                <el-table-column width="160px" fixed="left" :label="$t('devicePage.imei')" >
                    <!-- <el-tooltip v-if="scope.row.outer_device_id" slot-scope="scope" :content="'电信平台ID: '+scope.row.outer_device_id" placement="top">
                        <div>{{scope.row.imei}}</div>
                    </el-tooltip> -->
                    <div slot-scope="scope" @click="goLogbook(scope.row.id)" class="id-link">
                        <!-- {{ scope.row.uid !== '' ? scope.row.uid : (scope.row.type === 0 ? scope.row.imei : scope.row.eui)}} -->
                        <div v-if="scope.row.uid !== ''">{{scope.row.uid}}</div>
                        <div v-if="scope.row.uid === '' && scope.row.type === 0">{{scope.row.imei}}</div>
                        <div v-if="scope.row.uid === '' && scope.row.type === 1">{{scope.row.eui}}</div>
                    </div>
                </el-table-column>
                <!-- 第三方平台ID -->
                <el-table-column width="200px"  :label="$t('devicePage.outer_device_id')" v-if="user.role === 1">
                    <div slot-scope="scope">{{scope.row.outer_device_id}}</div>
                </el-table-column>
                <!-- <el-table-column width="140px" prop="eui" :label="$t('devicePage.eui')" ></el-table-column> -->
                <!-- 类型 -->
                <el-table-column width="64px" prop="type" :label="$t('devicePage.type')" >
                    <div class="table-outer-status" slot-scope="scope">
                        {{scope.row.type | deviceType()}}
                    </div>
                </el-table-column>
                <!-- 工作机编号 -->
                <el-table-column width="180px" prop="device_sn" :label="$t('devicePage.lubricator_number')" align="center">
                    <div class="table-outer-status" slot-scope="scope">
                        {{scope.row.device_sn }}
                    </div>
                </el-table-column>
                <!-- <el-table-column width="90px" prop="gateway_eui" :label="$t('devicePage.gateway_eui')" ></el-table-column> -->
                <!--状态-->
                <el-table-column  width="150px" :label="$t('devicePage.equipmentStatus')" align="center">
                    <div class="table-outer-status" slot-scope="scope">
                        <div v-if="scope.row.status === 0"><el-alert :title="$t('selectData.device.status.status0')" :closable="false" type="success" style="color:black;background: #88c008"/></div>
                        <div v-if="scope.row.status === 1"><el-alert :title="$t('selectData.device.status.status1')" :closable="false" type="warning" style="color:black;background: #F8E71C"/></div>
                        <div v-if="scope.row.status === 2"><el-alert :title="$t('selectData.device.status.status2')" :closable="false" type="error"   style="color:black;background: #ff0000"/></div>
                        <div v-if="scope.row.status === 3"><el-alert :title="$t('selectData.device.status.status3')" :closable="false" type="info"    style="color:white;background: #99a5aa"/></div>
                        <div v-if="scope.row.status === 4"><el-alert :title="$t('selectData.device.status.status4')" :closable="false" type="info"    style="color:white;background: #99a5aa"/></div>
                        <div v-if="scope.row.pending_setting === 0" style="margin-left: 5px">
                            <el-alert :closable="false" :title="$t('selectData.device.status.pending_setting')" type="info" style="color:black;background: #F8E71C;"/>
                        </div>
                    </div>
                </el-table-column>
                <!-- 错误详情 -->
                <el-table-column :label="$t('devicePage.error')" width="140px" >
                    <!-- <div slot-scope="scope" style="white-space: pre-wrap;"> -->
                    <div slot-scope="scope">
                        {{scope.row.error_type | filterErrorType}}
                    </div>
                </el-table-column>

                <!--温度-->
                <el-table-column width="100px" :label="$t('devicePage.temperature')">
                    <div slot-scope="scope">{{scope.row.current_temperature == 65535.0 || scope.row.current_temperature ==='' ? $t('devicePage.unAvailable') : scope.row.current_temperature ? scope.row.current_temperature + "℃" : ""}}</div>
                </el-table-column>
                <!--信号-->
                <el-table-column  width="100px" :label="$t('devicePage.signal')">
                    <div slot-scope="scope" >
                        <div v-if="scope.row.rssi === ''">{{$t('devicePage.unAvailable')}}</div>
                        <div v-else><img :src="scope.row.rssi" style="height: 25px;width: 25px" alt=""></div>
                    </div>
                </el-table-column>
                <!--电量-->
                <el-table-column   width="130px" :label="$t('devicePage.quantity')">
                    <div slot-scope="scope" v-if="scope.row.battery_power && scope.row.battery_power >= 0" style="position: relative;top: 5px;">
                        <!--prop="battery_power"-->
                        <img style="width: 21px;height: 14px;" src="../assets/img/btn/electric.png" alt="">
                        <div class="electric" >
                            <!--CSS电量矢量图-->
                            <div :style="{
                            width: scope.row.battery_power + '%',
                            background: scope.row.battery_power <= 20 ? '#eb202a' : '#46962b'
                            }"></div>
                        </div>
                    </div>
                    <div v-else-if="scope.row.battery_power === ''">{{ $t('devicePage.unAvailable') }}</div>
                </el-table-column>
                <!--可用率-->
                <el-table-column   width="90px" :label="$t('devicePage.availability')">
                    <div slot-scope="scope">
                        <div>{{scope.row.lubricant_left<0 ? '-' : scope.row.lubricant_left }}%</div>
                    </div>
                </el-table-column>
                <!--周数-->
                <el-table-column width="135px"  :label="$t('devicePage.AvailableInWeeks')" >
                    <div slot-scope="scope">{{scope.row.lubricant_available_days/7 >= 0 ? (scope.row.lubricant_available_days/7).toFixed(0) + $t('devicePage.week') :  '-'}}</div>
                </el-table-column>
                <!--所属客户-->
                <el-table-column  prop="company"  width="160px"  :label="$t('devicePage.customer')"></el-table-column>
                <!--频段-->
                <el-table-column  prop="lora_band"  width="160px"  :label="$t('devicePage.lora_band')"></el-table-column>
                <!--邮箱-->
                <el-table-column  prop="email"  min-width="180px"  :label="$t('devicePage.email')" v-if="user.role === 1"></el-table-column>
                <!--应用设备类型-->
                <el-table-column prop="application" min-width="100px" :label="$t('devicePage.application')"></el-table-column>
                <!--设备名称-->
                <el-table-column prop="name" min-width="120px" :label="$t('devicePage.deviceName')"  ></el-table-column>
                <!--资产标签-->
                <el-table-column prop="asset_tag" min-width="120px" :label="$t('devicePage.asset_tag')"></el-table-column>
                <!--安装位置-->
                <el-table-column prop="install_location" min-width="140px" :label="$t('devicePage.install_location')"></el-table-column>
                <!--地区-->
                <el-table-column  :label="$t('devicePage.region')" min-width="120px">
                    <div slot-scope="scope">{{scope.row.province}}{{scope.row.city}}</div>
                </el-table-column>
                <!--活跃时间-->
                <el-table-column  :label="$t('devicePage.activeTime')" min-width="155px">
                    <span slot-scope="scope">{{scope.row.last_report_time | timeFormat(1)}}</span>
                    <!-- {{scope.row.update_time | timeFormat(1)}} -->
                </el-table-column>

                <!-- addr -->
                <!-- <el-table-column prop="addr" min-width="140px" :label="$t('devicePage.addr')"></el-table-column> -->
                <!-- 安装位置 -->
                <!-- <el-table-column prop="nwks_key" min-width="140px" :label="$t('devicePage.nwks_key')"></el-table-column> -->
                <!-- 安装位置 -->
                <!-- <el-table-column prop="apps_key" min-width="140px" :label="$t('devicePage.apps_key')"></el-table-column> -->

                <!--服务商-->
                <el-table-column prop="agent"  width="90px" v-if="user.role === 1" :label="$t('devicePage.dealer')"></el-table-column>
                <el-table-column v-if="pageType === 'home'" prop="email" :label="$t('devicePage.logbook')">
                    <div slot-scope="scope" @click="goLogbook(scope.row.id)">
                        <el-button style="color: #0F58D6;cursor: pointer;padding: 3px 6px;">{{$t("devicePage.details")}}</el-button>
                    </div>
                </el-table-column>
                <el-table-column width="70px" :label="$t('devicePage.operation')" fixed="right"  v-if="pageType === 'device' && user.role !==10 ">
                    <div slot-scope="scope" class='my-table-button'>
                        <!-- <img src="../assets/img/btn/edit.png"   v-if="user.role !== 1 && user.role !== 2" @click="editDevice(scope.row)"> -->
                        <img src="../assets/img/btn/edit.png"   v-if="user.role !== 2" @click="editDevice(scope.row)">
                        <!--<img src="../assets/img/icon/authority-no.png" v-if="!scope.row.is_enable"  @click="banDevice(scope.row)">-->
                        <!--<img src="../assets/img/icon/authority-off.png" v-else  @click="banDevice(scope.row)">-->
                        <img src="../assets/img/icon/authority-del.png"  v-if="(user.role === 1 || user.role === 100) && scope.row.type === 0" @click="deleteDevice(scope.row)" alt="">
                        <img src="../assets/img/icon/authority-del.png"  v-if="(user.role === 1 || user.role === 100) && scope.row.type === 1" @click="deleteDeviceLora(scope.row)" alt="">
                    </div>
                </el-table-column>
            </el-table>
        </div>
        <!-- 移动端 -->
        <div class="phone-log-table-list" v-if="phoneClass" :style="{'opacity': mobileSearch.handleScreen ? '0.2': '1'}">
            <div class="phone-log-table-item" v-for="(item, index) in deviceList" :key="index" @click.stop="mobileSearch.handleScreen?screen():infoDetail(item)">
                <div class="top">
                    <div class="left">
                        <div class="no">
                            <div v-if="item.uid !== ''">{{item.uid}}</div>
                            <div v-if="item.uid === '' && item.type === 0">{{item.imei}}</div>
                            <div v-if="item.uid === '' && item.type === 1">{{item.eui}}</div>
                        </div>
                        <div class="status">
                            <div v-if="item.status === 0">
                                <el-alert
                                    :title="$t('selectData.device.status.status0')"
                                    type="success"
                                    style="color:black;background: #88c008"
                                    :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="item.status === 1">
                                <el-alert
                                    :title="$t('selectData.device.status.status1')"
                                    type="warning"
                                    style="color:black;background: yellow"
                                    :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="item.status === 2">
                                <el-alert
                                    :title="$t('selectData.device.status.status2')"
                                    type="error"
                                    style="color:black;background: red"
                                    :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="item.status === 3">
                                <el-alert
                                    :title="$t('selectData.device.status.status3')"
                                    type="info"
                                    style="color:white;background: #99a5aa"
                                    :closable="false">
                                </el-alert>
                            </div>
                            <div v-else-if="item.status === 4">
                                <el-alert
                                    :title="$t('selectData.device.status.status4')"
                                    type="info"
                                    style="color:white;background: #99a5aa"
                                    :closable="false">
                                </el-alert>
                            </div>
                            <div v-if="item.pending_setting === 0" style="margin-left: 5px">
                                <el-alert
                                    :title="$t('selectData.device.status.pending_setting')"
                                    type="info"
                                    style="color:black;background: #F8E71C"
                                    :closable="false">
                                </el-alert>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="battery">
                            <div v-if="item.battery_power && item.battery_power >= 0" style="position: relative;top: 5px;">
                                <!--prop="battery_power"-->
                                <img style="width: 21px;height: 14px;" src="../assets/img/btn/electric.png" alt="">
                                <div class="electric" >
                                    <!--CSS电量矢量图-->
                                    <div :style="{
                                    width: item.battery_power + '%',
                                    background: item.battery_power <= 20 ? '#eb202a' : '#46962b'
                                    }"></div>
                                </div>
                            </div>
                            <div v-else-if="item.battery_power === ''">{{ $t('devicePage.unAvailable') }}</div>
                        </div>
                        <div class="battery">
                            <div v-if="item.rssi === ''">
                                暂无
                            </div>
                            <div v-else>
                                <img :src="item.rssi" style="height: 25px;width: 25px" alt="">
                            </div>
                        </div>
                        <div class="signal">
                            {{item.current_temperature == 65535.0 || item.current_temperature ==='' ? '-℃' : item.current_temperature ? item.current_temperature + "℃" : ""}}
                        </div>
                    </div>
                </div>
                <div class="middle">
                    <!-- <img src="../assets/img/icon/map-adr.png" alt=""> -->
<!--                    <div class="adr">{{ $t('dealerPage.address') }}: {{item.address || '暂无'}}</div>-->
                    <div class="per">{{ $t('devicePage.lubricator_number') }}: {{item.device_sn ? item.device_sn : '-' }}</div>
                </div>
                <div class="middle">
                    <!-- <img src="../assets/img/icon/map-percentage.png" alt=""> -->
                    <div class="per">{{ $t('devicePage.availability') }}: {{item.lubricant_left<0 ? '-' : item.lubricant_left }}%</div>
                </div>
                <div class="middle">
                    <!-- <img src="../assets/img/icon/map-percentage.png" alt=""> -->
                    <div class="per">{{ $t('devicePage.activeTime') }}: {{item.last_report_time | timeFormat(1)}}</div>
                </div>
                <div class="middle">
                    <!-- <div class="per">错误详情: {{ (item.error_type | filterErrorType) || '-'}}</div> -->
                    <div class="per">{{ $t('devicePage.error') }}: {{item.error_type | filterErrorType}}</div>
                </div>
                <div class="btns" v-if="pageType === 'home'">
                    <!-- @click="goLogbook(scope.row.id)" -->
                    <el-button type="primary" plain @click.stop="goLogbook(item.id)">日志</el-button>
                </div>
                <div class="btns" v-if="pageType ==='device'">
                    <!-- @click="goLogbook(scope.row.id)" -->
                    <el-button type="primary" plain v-if="user.role !== 2" @click.stop="mobileSearch.handleScreen?screen():editDevice(item)">编辑</el-button>
                    <el-button type="danger" plain v-if="(user.role === 1 || user.role === 100) && item.type === 0" @click.stop="mobileSearch.handleScreen?screen():deleteDevice(item)">解绑</el-button>
                    <el-button type="danger" plain v-if="(user.role === 1 || user.role === 100) && item.type === 1" @click.stop="mobileSearch.handleScreen?screen():deleteDeviceLora(item)">解绑</el-button>
                </div>
            </div>
        </div>
        <div class="pagination" style="text-align:right;padding:0 20px 5px 0;">
            <el-pagination
                @current-change="pageChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total"
                background>
            </el-pagination>
        </div>

        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="90%"
            :show-close="false"
        >
            <span slot="title" class="dialog-title">
                <div class="left">
                    <div class="id">
                        <div v-if="detailInfo.uid !== ''">{{detailInfo.uid}}</div>
                        <div v-if="detailInfo.uid === '' && detailInfo.type === 0">{{detailInfo.imei}}</div>
                        <div v-if="detailInfo.uid === '' && detailInfo.type === 1">{{detailInfo.eui}}</div>
                    </div>

                    <div class="status">
                        <div v-if="detailInfo.status === 0">
                            <el-alert
                                    :title="$t('selectData.device.status.status0')"
                                    type="success"
                                    style="color:black;background: #88c008"
                                    :closable="false">
                            </el-alert>
                        </div>
                        <div v-else-if="detailInfo.status === 1">
                            <el-alert
                                    :title="$t('selectData.device.status.status1')"
                                    type="warning"
                                    style="color:black;background: yellow"
                                    :closable="false">
                            </el-alert>
                        </div>
                        <div v-else-if="detailInfo.status === 2">
                            <el-alert
                                    :title="$t('selectData.device.status.status2')"
                                    type="error"
                                    style="color:black;background: red"
                                    :closable="false">
                            </el-alert>
                        </div>
                        <div v-else-if="detailInfo.status === 3">
                            <el-alert
                                    :title="$t('selectData.device.status.status3')"
                                    type="info"
                                    style="color:white;background: #99a5aa"
                                    :closable="false">
                            </el-alert>
                            <!--  TODO 临时验收处理-->
<!--                            <el-alert-->
<!--                                :title="$t('selectData.device.status.status0')"-->
<!--                                type="success"-->
<!--                                style="color:black;background: #88c008"-->
<!--                                :closable="false">-->
<!--                            </el-alert>-->
                        </div>
                        <div v-else-if="detailInfo.status === 4">
                            <el-alert
                                    :title="$t('selectData.device.status.status4')"
                                    type="info"
                                    style="color:white;background: #99a5aa"
                                    :closable="false">
                            </el-alert>
                        </div>
                        <div v-if="detailInfo.pending_setting === 0" style="margin-left: 5px">
                            <el-alert
                                    :title="$t('selectData.device.status.pending_setting')"
                                    type="info"
                                    style="color:black;background: #F8E71C"
                                    :closable="false">
                            </el-alert>
                        </div>
                    </div>
                </div>

                <div class="right">
                    <div class="battery">
                        <div v-if="detailInfo.battery_power && detailInfo.battery_power >= 0" style="position: relative;top: 5px;">
                            <!--prop="battery_power"-->
                            <img style="width: 21px;height: 14px;" src="../assets/img/btn/electric.png" alt="">
                            <div class="electric" >
                                <!--CSS电量矢量图-->
                                <div :style="{
                                width: detailInfo.battery_power + '%',
                                background: detailInfo.battery_power <= 20 ? '#eb202a' : '#46962b'
                                }"></div>
                            </div>
                        </div>
                        <div v-else-if="detailInfo.battery_power === ''">{{ $t('devicePage.unAvailable') }}</div>
                    </div>
                    <div class="battery">
                        <div v-if="detailInfo.rssi === ''">
                            暂无
                        </div>
                        <div v-else>
                            <img :src="detailInfo.rssi" style="height: 25px;width: 25px" alt="">
                        </div>
                    </div>
                    <div class="signal">
                            {{detailInfo.current_temperature == 65535.0 || detailInfo.current_temperature ==='' ? '-℃' : detailInfo.current_temperature ? detailInfo.current_temperature + "℃" : ""}}
                    </div>
                </div>
            </span>

            <div class="item">
                <div class="left">{{$t('devicePage.type')}}</div>
                <div class="right">{{detailInfo.type | deviceType()}}</div>
            </div>
            <div class="item">
                <div class="left">{{$t('devicePage.availability')}}</div>
                <div class="right">{{detailInfo.lubricant_left<0 ? '-' : detailInfo.lubricant_left }}%</div>
            </div>
            <div class="item">
                <div class="left">{{$t('devicePage.AvailableInWeeks')}}</div>
                <div class="right">{{detailInfo.lubricant_available_days/7 >= 0 ? (detailInfo.lubricant_available_days/7).toFixed(0) + $t('devicePage.week') :  '-'}}</div>
            </div>
            <div class="item">
                <div class="left">{{$t('devicePage.application')}}</div>
                <div class="right">{{detailInfo.application}}</div>
            </div>
            <div class="item">
                <div class="left">{{$t('devicePage.asset_tag')}}</div>
                <div class="right">{{detailInfo.asset_tag}}</div>
            </div>
            <div class="item">
                <div class="left">{{$t('devicePage.install_location')}}</div>
                <div class="right">{{detailInfo.install_location}}</div>
            </div>
            <div class="footer" @click="closeDialog">
                <img src="../assets/img/icon/home-close.png" alt="" style="width:30px;height:30px">
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="showEdit"
            width="70%"
            :show-close="false"
            :close-on-click-moda="false"
        >
            <deviceAddNew v-if="showEdit" :device_id="editId" @clickClose="closeEdit"></deviceAddNew>
        </el-dialog>

    </div>
</template>
<script>
import Core from 'core/core'
import {refresh} from "core/winSize"
import deviceAddNew from './device-add-card'
export default {
    props: {
        pageType: String,
    },
    components: {
        deviceAddNew
    },
    data() {
        return {
            phoneClass: '',
            red : 'blue',
            superShow : false,
            user: {
            },
            deviceList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            typeList: Core.Const.deviceType,
            searchForm: {
                key: '',
                status: '',
                site: '',
                dealer: '',
                type:'',
                province: '',
                city: '',
                application: '',
                lora_band: '',
                email: '',
            },
            deviceStatusList: Core.Const.deviceStatusList,
            style: {
                opacity: '0',
                top: '0px',
                rotate: 'rotate(180deg)',
                zIndex: '-1',
                height: '0px',
                background: '#f5f8fa',
                border: '1px #e4e8ec solid',
                color: '#175dd7'
            },
            loraBandList: [],
	        newSetInterval: '',

            mobileSearch: {
                isScreen: true,
                screenActive: false,
                handleScreen: false
            },
            dialogVisible: false,
            detailInfo: {},

            showEdit: false,
            editId: null,
            selectedDevices: [],
            dragDeviceIndex: -1,
        };
    },
    created(){
        this.initUserData()
	    refresh(this,'phoneClass-device-table');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-device-table');
		    },10)
	    };

	    this.newSetInterval = setInterval(()=>{
		    this.getDeviceList();
	    },10000)
    },
    mounted() {
        this.getDeviceList();
        this.getStorageList();
        this.getLoraBandAll()
    },
    beforeDestroy(){
        clearInterval(this.newSetInterval)
    },
    methods: {
        initUserData(){
          this.user = Core.Data.getUser()
	        // console.log (this.user,'user')
        },
        // 获取频段下拉选项，供列表筛选复用
        getLoraBandAll() {
            Core.Api.Fengine.getLoraBandList().then(res => {
                this.loraBandList = res.list || []
            })
        },
        deviceSuperBtn(){
            this.superShow = !this.superShow
            if(this.superShow){
                this.style.opacity = '1'
                this.style.top = '0'
                this.style.zIndex = '2'
                this.style.height= '80px'
                this.style.rotate = 'rotate(0)'
                this.style.background = '#f5f8fa'
                this.style.border = '1px #e4e8ec solid'
                this.style.color = '#175dd7'
            } else {
                this.style.opacity = "0"
                this.style.top = "0px"
                this.style.zIndex = "-1"
                this.style.height = '0px'
                this.style.rotate = 'rotate(-180deg)'
                this.style.background = '#f5f8fa'
                this.style.border = '1px #e4e8ec solid'
                this.style.color = '#175dd7'
            }
        },
        getStorageList() {
            Core.Api.Agent.listAll().then(res => {
                // let dealerList = res.agent_list;
                // this.dealerList = dealerList;
            })
        },
        getDeviceList() {
            Core.Api.Device.getDeviceList(this.currentPage, this.searchForm.status, this.searchForm.province, this.searchForm.city, this.searchForm.key, this.searchForm.application, this.searchForm.type, this.searchForm.lora_band, this.searchForm.email)
            .then(res => {
                res.list.map((item) => {
                    let rssi = item.rssi
                    // NB的rssi会放大10倍，lora的不会
                    if (item.type === Core.Const.DEVICE_TYPE.NB) {
                        rssi = rssi / 10
                    }
                    item.rssi = this.getSignalImgByRSSINew(rssi)
                })
                this.total = res.count;
                this.deviceList = res.list;
                this.$nextTick(() => {
                    this.bindDeviceDragEvent()
                })
            })
            .catch(err => {
                console.log('getDeviceList error: ', err);
            })
        },
        getSignalImgByRSSI(rssi) {
            if (rssi > -800) {
                return require("../assets/img/rssi/signal0.png");
            } else if (rssi > -900 && rssi <= -800) {
                return require("../assets/img/rssi/signal1.png");
            } else if (rssi > -1000 && rssi <= -900) {
                return require("../assets/img/rssi/signal2.png");
            } else if (rssi > -1100 && rssi <= -1000) {
                return require("../assets/img/rssi/signal3.png");
            } else if (rssi > -1200 && rssi <= -1100) {
                return require("../assets/img/rssi/signal4.png");
            } else if (rssi <= -1200) {
                return require("../assets/img/rssi/signal5.png");
            }
        },

        getSignalImgByRSSINew(rssi) {
            if (rssi > -75) {
                return require("../assets/img/rssi/signal5.png");
            } else if (rssi > -85 && rssi <= -75 ) {
                return require("../assets/img/rssi/signal4.png");
            } else if (rssi > -95 && rssi <= -85 ) {
                return require("../assets/img/rssi/signal3.png");
            } else if (rssi > -105 && rssi <= -95) {
                return require("../assets/img/rssi/signal2.png");
            } else if (rssi > -115 && rssi <= -105) {
                return require("../assets/img/rssi/signal1.png");
            } else if (rssi <= -115 ) {
                return require("../assets/img/rssi/signal0.png");
            }
        },
        pageChange(val) {
            this.currentPage = val;
            this.getDeviceList();
        },
        create(){
            for (let x in this.searchForm) {
                this.searchForm[x]=''
            }
            this.getDeviceList()
        },
        editDevice(row) {
            // console.log(row.imei);
            if(!row.id) {
                return
            }
            if(this.phoneClass) {
                this.$router.push(`/device/add?device_id=${row.id}`)
            } else {
                this.editId = row.id;
                this.showEdit = true;
            }
            // this.$router.push(`/device/add?device_id=${row.id}`)
        },
        initPage(){
            this.currentPage = 1
	        console.log ('现在是第',this.currentPage)
        },
        banDevice(row) {
	        if(!row.is_enable){
                this.$confirm('您确定要禁用该设备吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Core.Api.Device.enable(row.id).then((res)=>{
                        this.getDeviceList();
                        this.$message({
                            type: 'success',
                            message: '禁用成功!'
                        });
                    })
                })
            } else {
                Core.Api.Device.enable(row.id).then((res)=>{
                    this.getDeviceList();
                })
            }
        },
        deleteDevice(row){
            // console.log(row.id)
            this.$confirm('您确定要解绑该设备吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: this.phoneClass?'message-box':''
            }).then(() => {
                Core.Api.Device.unbindDevice(row.id).then((res)=>{
                    this.$message({
                        type: 'success',
                        message: '解绑成功!'
                    });
                    this.getDeviceList();
                })
            })
        },
        deleteDeviceLora(row){
            // console.log(row.id)
            this.$confirm('您确定要解绑该设备吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: this.phoneClass?'message-box':''
            }).then(() => {
                Core.Api.Device.deleteDevice(row.id).then((res)=>{
                    this.$message({
                        type: 'success',
                        message: '解绑成功!'
                    });
                    this.getDeviceList();
                })
            })
        },
	    handleSelectionChange(selection) {
            this.selectedDevices = selection;
        },
        handleBatchDelete() {
            if (this.selectedDevices.length === 0) {
                this.$message({
                    type: 'warning',
                    message: this.$t('devicePage.batchDeleteSelectWarning')
                });
                return;
            }
            this.$confirm(this.$t('devicePage.batchDeleteConfirm'), this.$t('devicePage.batchDeleteWarning'), {
                confirmButtonText: this.$t('devicePage.confirm'),
                cancelButtonText: this.$t('devicePage.cancel'),
                type: 'warning',
                customClass: this.phoneClass?'message-box':''
            }).then(() => {
                Core.Api.Device.deleteDeviceList(this.selectedDevices.map(item => item.id)).then((res) => {
                    this.$message({
                        type: 'success',
                        message: this.$t('devicePage.batchDeleteSuccess')
                    });
                    this.selectedDevices = [];
                    this.getDeviceList();
                }).catch((err) => {
                    console.log('batch delete error: ', err);
                    this.$message({
                        type: 'error',
                        message: this.$t('devicePage.batchDeleteFailed')
                    });
                });
            }).catch(() => {});
        },
        // 给设备行绑定原生拖拽事件，用于自定义排序
        bindDeviceDragEvent() {
            if (this.phoneClass || this.pageType !== 'device') {
                return
            }
            if (!this.$refs.deviceTable || !this.$refs.deviceTable.$el) {
                return
            }
            const rowNodeList = this.$refs.deviceTable.$el.querySelectorAll('.device-sort-row')
            rowNodeList.forEach((rowNode, index) => {
                rowNode.setAttribute('draggable', 'true')
                rowNode.ondragstart = () => {
                    this.dragDeviceIndex = index
                }
                rowNode.ondragover = (event) => {
                    event.preventDefault()
                }
                rowNode.ondrop = (event) => {
                    event.preventDefault()
                    this.dropDeviceRow(index)
                }
            })
        },
        // Element 表格行样式，同时作为拖拽绑定选择器
        getDeviceRowClassName() {
            return this.pageType === 'device' && !this.phoneClass ? 'device-sort-row' : ''
        },
        // 拖拽结束后保存单个设备移动位置
        dropDeviceRow(targetIndex) {
            if (this.dragDeviceIndex < 0 || this.dragDeviceIndex === targetIndex) {
                this.dragDeviceIndex = -1
                return
            }
            const deviceList = this.deviceList.slice()
            const oldDeviceList = this.deviceList.slice()
            const deviceId = deviceList[this.dragDeviceIndex].id
            const targetDeviceId = deviceList[targetIndex].id
            const sortPosition = this.dragDeviceIndex < targetIndex ? 'after' : 'before'
            const dragDeviceList = deviceList.splice(this.dragDeviceIndex, 1)
            deviceList.splice(targetIndex, 0, dragDeviceList[0])
            this.deviceList = deviceList
            this.dragDeviceIndex = -1
            Core.Api.Device.sortDevice(deviceId, targetDeviceId, sortPosition).then(() => {
                this.$message({
                    type: 'success',
                    message: '排序已保存'
                });
                this.getDeviceList()
            }).catch(() => {
                this.deviceList = oldDeviceList
                this.$nextTick(() => {
                    this.bindDeviceDragEvent()
                })
            })
        },
        goLogbook(id) {
	        this.$router.push({
	            path: '/home/logbook?id=' + id
	        })
	    },

        screen() {
            this.mobileSearch.handleScreen = !this.mobileSearch.handleScreen;
        },
        infoDetail(item) {
            console.log('item: ', item);
            this.dialogVisible = true
            this.detailInfo = item
        },
        closeDialog() {
            this.dialogVisible = false
        },
        closeEdit(isSave) {
            this.showEdit = false;
            if(isSave) this.getDeviceList();
        }
    },
};
</script>
<style scoped lang='scss'>
@import '../assets/style/mixin.scss';
.device-table {
    .search-bar {
        @include flex-sb;
        padding: 10px 0 0 20px;
        .status-index {
            margin-right: 12px;
            &:last-child {
                margin-right: 0;
            }
        }
    }

}
</style>
<style lang="scss">
// .device-table {
//     min-height: 854px;
//     .normal-table {
//     }
// }
.device-table{
    .electric {
        width: 13px;
        height: 8px;
        position: relative;
        top: -18px;
        left: 3px;
        transform: translateY(-5%);
        >div {
            background: green;
            height: 100%;
        }
    }
    .table-outer {
        margin: 0 20px;
        .my-table-button {
            display: flex;
            justify-content: space-around;
            img {
                margin: 0;
                vertical-align: middle;
                cursor: pointer;
            }
            /*img:last-child {*/
                /*margin-right: 0;*/
            /*}*/
        }
        /*状态样式*/
        .table-outer-status {
            > div {
                text-align: center;
                display: inline-block;
                white-space:nowrap !important;
            }
        }
        .el-alert {
            margin: 0;
            padding: 0;
            min-width: 48px;
            height: 26px;
            font-size: 10px !important;
            .el-alert__content{
                margin: 0 auto;
                padding: 0 13px;
                text-align: center;
                .el-alert__title {
                    margin: 0 auto;
                    font-size: 10px !important;

                }
            }
        }
        .el-alert--success{
            background: #e0f5e5;
            color: #2DBC4F;
        }
        .el-alert--info {
            background: #e8e9fb;
            color: #626BE3;
        }
        .id-link {
            cursor: pointer;
            color: #626BE3;
            // text-decoration:underline;
        }
        // .cell {
            // white-space:nowrap;
            // overflow:hidden; //超出的文本隐藏
            // text-overflow:ellipsis; //溢出用省略号显示
        // }
        // .cell:hover {
        //     white-space: normal;
        //     overflow: visible; //超出的文本隐藏
        //     position: relative;
        //     z-index: 10000;
        //     text-overflow:clip;
        // }
    }
    .el-table__row {
        * {
            font-size: 13px !important;

        }
    }
    .deviceSuperBtn {
        margin-right: 20px;
        button {
            /*border: 1px #e4e8ec solid;*/
            /*color: #175dd7;*/
            padding: 4px 10px;
            span {
                margin-right: 3px;
            }
        }
    }
    .superBtn {
        border-top: 1px #fafbfc solid;
        transition: 500ms;
        position: relative;
        opacity: 0;
        z-index: -1;
        top: -60px ;
        .status-index .el-input__inner{
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
        }
    }

    .status-index {
        display: flex;
        align-items: center;
        /*vertical-align: top;*/

        .top-title {
            border: 1px solid rgba(7, 17, 27, .1);
            border-right: none;
            border-radius: 4px 0 0 4px;
            min-width: 60px;
            height: 32px;
            background-color: #F5F7F9;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #80868B;
            cursor: pointer;
        }
        .el-select {
            width: 243px;
            .el-input__inner {
                height: 32px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
        .el-input__inner {
            height: 32px;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        .input-index {
            position: relative;
            img {
                position: absolute;
                width: 20px;
                height: 20px;
                top: 8px;
                right: 8px;
                cursor: pointer;
            }
            .el-input__inner {
                width: 300px;
                height: 34px;
                box-sizing: border-box;
                border-radius: 3px;
                padding-right: 30px;
            }
        }
    }
}

.phoneClass-device-table {

    .electric {
        width: 15px;
        height: 8px;
        position: relative;
        top: -18px;
        left: 3px;
        >div {
            background: green;
            height: 100%;
        }
    }
    .search-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        padding: 4px 16px 4px 21px;
        border: 1px solid #EDF0F3;
        border-left: none;
        border-right: none;
        .left {
            width: 68%;
            &::after {
                content: " ";
                border-right: 1px solid #E2E2E2;
                margin-left: 17px;
            }
            .el-input__inner {
                border-radius: 16px !important;
                background: #F4F7F9;
                border: none;
            }
        }
        .right {
            display: flex;
            align-items: center;
            .screen {
                img {
                    margin-left: 5px;
                    width: 10px;
                    height: 12px;
                }
            }
            .handleScreen {
                color: #0F58D6
            }
        }
    }
    .search-bar {
        margin-top: 0px;
        padding: 20px 16px !important;
        background: white;
        align-items: inherit;
        position: absolute;
        width: 100%;
        z-index: 999;
        .status-index {
            display: flex;
            flex-direction: column;
            margin-bottom: 16px;
            span {
                font-size: 14px;
                font-weight: 500;
                color: #2D2E32;
                line-height: 20px;
                margin-bottom: 10px;
            }
            .el-select {
                width: 100% !important;
            }
        }
        .btns {
            display: flex;
            justify-content: space-between;
            flex-direction: row;

            .el-button {
                font-size: 17px;
                width: calc((100% - 11px) / 2) !important;
                &:first-child {
                    color: #0F58D6;
                }
            }
        }
    }
    .el-alert {
        margin: 0;
        padding: 0;
        min-width: 48px;
        height: 26px;
        font-size: 10px !important;
        /*display: inline-block;*/
        .el-alert__content{
            margin: 0 auto;
            padding: 0;
            .el-alert__title {
                margin: 0 auto;
                font-size: 10px !important;

            }
        }
    }
    .phone-log-table-list {
        padding: 12px;
        .phone-log-table-item {
            box-sizing: border-box;
            background: white;
            margin-bottom: 12px;
            padding: 12px 17px;
            border-radius: 4px;
            .top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;
                .left {
                    display: flex;
                    align-items: center;
                    .no {
                        font-size: 16px;
                        font-weight: bold;
                        color: #465159;
                        line-height: 22px;
                        margin-right: 12px;
                    }
                    .status {
                        width: auto;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        justify-content: flex-start;
                    }
                }
                .right {
                    display: flex;
                    align-items: center;
                    .battery {
                        margin-right: 10px;
                        .electric {
                            top: -15px;
                        }
                    }
                }
            }
            .middle {
                margin-bottom: 8px;
                display: flex;
                &:last-child {
                    margin-bottom: 0px;
                }
                img {
                    width: 15px;
                    margin-right: 10px;
                }
            }
            .bottom {
                img {
                    width: 15px;
                    margin-right: 10px;
                }
                display: flex;
            }
            .btns {
                justify-content: right;
                text-align: right;
            }
        }
    }

    /*页码适配移动端*/
    .pagination {
        padding: 0 0 20px 0 !important;
        text-align: center !important;
        .el-pagination {
            margin-bottom: 50px;
            padding: 0;
            button {
                width: 20px;
                min-width: 0;
                height: 30px;
            }
            .el-pager {
                .number {
                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
                .el-icon-more {
                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
            }
        }
    }
    // 详情弹窗--移动端
    .el-dialog {
        .dialog-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
                display: flex;
                align-items: center;
                .id {
                    margin-right: 8px;
                    font-size: 16px;
                    font-weight: 500;
                    color: #465159;
                    line-height: 22px;
                }
                .status {
                    display: flex;
                    flex-wrap: wrap;
                    .el-alert {
                        width: auto;
                        height: auto;
                        padding: 2px 4px;
                    }
                }
            }
            .right {
                display: flex;
                align-items: center;
                .battery {
                    margin-right: 15px;
                    .electric {
                        top: -15px;
                    }
                }
            }
        }
        .el-dialog__body {
            padding: 0px 16px 7px;
            .item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 14px 0;
                border-bottom: 1px solid #EDF0F3;
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
                .left {
                    color: #878E98;
                }
                .right {
                    color: #363D42;
                }
            }
            .footer {
                position: absolute;
                bottom: -40px;
                left: 50%;
                transform: translateX(-50%);
                img {
                    width: 28px;
                    height: 28px;
                }
            }
        }
    }
}
.el-message--error {
    top: 50% !important;
}
</style>
<style lang="scss">
.message-box {
    width: 90% !important;
}
</style>
